import SocialVideoCell, { SocialVideoCellProps } from './SocialVideoCell';

export default SocialVideoCell;
export type { SocialVideoCellProps };
